import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import App from '../common/app'
import WebOrderComponent from './components/index'
import { getWebOrder } from './actions'

function render (mountNode) {
  return function () {
    renderWithRoot(
      <App active="web-orders" {...getState()} {...appActions}>
        <WebOrderComponent {...getState()} {...appActions} />
      </App>,
      mountNode
    )
  }
}

let unsubscribe = function () {}

export default function (app, mountNode) {
  app('/web-orders/:referenceNumber', context => {
    unsubscribe = subscribe(render(mountNode))
    if (getState().session.id) {
      getWebOrder(context.params['referenceNumber'])
    }

    render(mountNode)()
  })

  app.exit('/web-orders/:referenceNumber', (context, next) => {
    unsubscribe()
    next()
  })
}
